export default {
    firstName: '',
    lastName: '',
    street: '',
    postalCode: '',
    phone: '',
    email: '',
    productInterest: '',
    freeWaterTest: '',
    appointmentRequest: '',
    preferredTime: '',
    preferredDate: '',
    message: '',
    nurture: '',
};
